import { Box, IconButton, MenuItem, Select, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions'
import React from 'react'
import { LeftArrowFilledIcon, LeftArrowStrokeIcon, RightArrowFilledIcon, RightArrowStrokeIcon } from 'src/Libs/flow/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const StyledSelect = styled(Select)(() => ({
  width: '50px',
  fontSize: '14px',
  boxShadow: 'none',
  margin: '0px 24px 0px 8px',
  '.MuiOutlinedInput-notchedOutline': {
    border: 0,
  },
  '& > .MuiOutlinedInput-input': {
    textAlign: 'right',
    minWidth: '16px',
    padding: '4px 24px 5px 8px !important',
  },
  svg: {
    right: '2px',
  },
}))

export const HagerTablePaginationActions: React.FC<TablePaginationActionsProps & { pageLabelSpacing?: number }> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  pageLabelSpacing,
}) => {
  const { t } = useCustomTranslation()
  const lastPage = Math.ceil(count / rowsPerPage) - 1
  const totalPages = Math.floor(count / rowsPerPage)

  // Array of consecutive numbers: 0,1,2,... up to the number of total pages
  const pageOptions: number[] = totalPages <= 0 ? [0] : Array.from(Array(totalPages + 1).keys())

  const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    onPageChange(event, 0)
  }

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    onPageChange(event, page + 1)
  }

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    onPageChange(event, Math.max(0, lastPage))
  }

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }} className="page-select-wrapper">
        <Typography sx={{ fontSize: '14px', pl: pageLabelSpacing }}>{t('pagination.page')}</Typography>

        <StyledSelect
          onChange={event => {
            const selectedPAge = event.target.value as number
            onPageChange?.(null, selectedPAge)
          }}
          value={page}
          fullWidth={false}
          disabled={pageOptions.length < 2}
        >
          {pageOptions.map(item => (
            <MenuItem key={item} value={item}>
              {item + 1}
            </MenuItem>
          ))}
        </StyledSelect>
      </Box>

      <Box sx={{ flexShrink: 0, ml: 2.5 }} className="arrowWrapper">
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
          <LeftArrowFilledIcon />
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          <LeftArrowStrokeIcon />
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= lastPage} aria-label="next page">
          <RightArrowStrokeIcon />
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page === lastPage || lastPage <= 0} aria-label="last page">
          <RightArrowFilledIcon />
        </IconButton>
      </Box>
    </>
  )
}
